import "./HamburgerIcon.scss";

import { useLayout } from "providers";

export const HamburgerIcon: React.FC = () => {
  const { isHamburgerOpen, setIsHamburgerOpen } = useLayout();

  return (
    <button className="btn btn-text sbb-hamburger-icon" onClick={() => setIsHamburgerOpen(!isHamburgerOpen)}>
      <i className="ms-Icon ms-Icon--GlobalNavButton" />
    </button>
  );
};
